var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('export-excel',{staticClass:"btn btn-outline-success",attrs:{"data":_vm.data,"name":_vm.name}},[_c('b-icon',{attrs:{"icon":"file-excel","aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.buttonText)+" ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }